import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  date: {
    id: 'lahitapiolaSubForm.date',
    defaultMessage: 'Päivämäärä',
  },
  time: {
    id: 'lahitapiolaSubForm.time',
    defaultMessage: 'Aika',
  },
  towingReason: {
    id: 'lahitapiolaSubForm.towingReason',
    defaultMessage: 'Hinauksen syy',
  },
  caseNumber: {
    id: 'lahitapiolaSubForm.caseNumber',
    defaultMessage: 'Viite',
  },
  billingInfo: {
    id: 'lahitapiolaSubForm.billingInfo',
    defaultMessage: 'Laskutus',
  },
  additionalInfo: {
    id: 'lahitapiolaSubForm.additionalInfo',
    defaultMessage: 'Lisäselvitykset',
  },
  notes: {
    id: 'lahitapiolaSubForm.notes',
    defaultMessage: 'Muistiinpanot',
  },
  deliverable: {
    id: 'lahitapiolaSubForm.deliverable',
    defaultMessage: 'Toimenpide',
  },
  cause: {
    id: 'lahitapiolaSubForm.cause',
    defaultMessage: 'Vika',
  },
})
